export default {
    pageTitle: 'My Membership',
    vip: 'My Membership',
    card1: 'Platinum Card',
    card2: 'Diamond Card',
    card3: 'Black Card',
    card4: 'Black',
    wan: 'K',
    tip1: 'Last Month Avg Assets ≥ ',
    tip1after: 'K USD, Enjoy ',
    v1: 'V1 Benefits',
    v2: 'V2 Benefits',
    v3: 'V3 Benefits',
    qrcode1: 'Save QR Code, Scan with WeChat',
    qrcode2: 'Add Your Dedicated Manager for Privileges',
    add: 'Added',
    lookMoney: 'View Assets',
    privilege: 'Exclusive Privileges',
    gift: 'Exclusive Gifts',
    giftLevel: 'Gift Level',
    giftDes: '「Fosun Wealth Star Gifts」 is a global wealth management service for high-net-worth investors.',
    giftLevelDes: 'Gifts are divided into 3 levels based on the average AUM assets of the past month. Higher levels offer more exclusive services.',
    privilege1: 'Health Protection',
    privilege2: 'Happy Life',
    privilege3: 'Travel & Leisure',
    privilege4: 'Privilege Box',
    privilege5: 'Privilege Link',
    btn1: 'Deposit Funds',
    btn2: 'Go to Trade',
    level: 'Current Level',
    nodb: 'Not Qualified',
    qidai: 'More Benefits Coming Soon',
    nosatisfy: 'Your Last Month Avg Assets Did Not Meet Requirements',
    lookMore: 'View More',
    lookLess: 'Collapse',
    comingSoonTips: 'High-end Benefits Coming Soon',
    aumyip: '*Upgraded on the 1st of the next month after AUM meets requirements',
    qy: 'Benefits',
    autoTip: 'Will Automatically Get',
    ling: 'Also',
    tips: 'Securities prices can be volatile. Prices may rise or fall, potentially becoming worthless. Trading securities may not always yield profits and could result in losses. The above is for reference only and should not be considered as advice, promotion, or solicitation to buy any investment product. Before trading, clients should make investment decisions based on personal goals and circumstances, and seek independent professional advice if needed. Content may change without notice.',
    dialogTip: 'You will leave Star Wealth APP to access 【Star Wealth Exclusive】 WeChat Mini Program to view and use benefits.',
    dialogTip1: 'Please update the APP version in 【My】- 【About Us】 to view Star Wealth Exclusive details.',
    dialogBtn: 'Confirm',
    dialogBtn1: 'Update Now',
}
